import styles from '../cartcheckout.module.scss';
import {
  CartBodyLabelsProps,
  CartConfirmationProps,
  CheckoutContainerProps,
  SummaryProps,
} from '@msc-b2c/interfaces/types';
import { CartHeader } from '../components/CartHeader/CartHeader';
import { CartBody } from '../components/CartBody/CartBody';
import { useSelector } from 'react-redux';
import { RootState } from '@msc-b2c/shared-utils';
import { PrepaidPaymentConfirmation } from '../components/prepaidpaymentconfirmation/PrepaidPaymentConfirmation';
import { PageType } from '@msc-b2c/interfaces/enums';

export function CheckoutContainer(props: Readonly<CheckoutContainerProps>) {
  const { items: cart, confirmation } = useSelector((state: RootState) => state.myAreaCart);

  const confirmationProps: CartConfirmationProps = {
    confirmationIcon: props.confirmationIcon,
    confirmationTitle: props.confirmationTitle,
    confirmationEmailText: props.confirmationEmailText,
    primaryConfirmationButton: props.primaryConfirmationButton,
    secondaryConfirmationButton: props.secondaryConfirmationButton,
    confirmationDetailsTitle: props.confirmationDetailsTitle,
    confirmationCheckoutNumber: props.confirmationCheckoutNumber,
    checkoutConfirmationDate: props.checkoutConfirmationDate,
    confirmationOrderSummaryTitle: props.confirmationOrderSummaryTitle,
  };

  const summaryProps: SummaryProps = {
    summarySectionTitle: props.summarySectionTitle,
    summarySubTotalText: props.summarySubTotalText,
    summaryTaxesText: props.summaryTaxesText,
    summarySavedMoneyText: props.summarySavedMoneyText,
    summaryTotalText: props.summaryTotalText,
  };

  const cartProps: CartBodyLabelsProps = {
    passengersFieldText: props.passengersFieldText,
    durationFieldText: props.durationFieldText,
    durationValueLabel: props.durationValueLabel,
    reservationFieldText: props.reservationFieldText,
    dayLabelText: props.dayLabelText,
    dayAtSeaLabelText: props.dayAtSeaLabelText,
    discountDescriptionText: props.discountDescriptionText,
  };

  return (
    <div className={styles['cmp-checkout-container']}>
      {(!!confirmation && (
        <PrepaidPaymentConfirmation
          cartItems={cart}
          confirmation={confirmationProps}
          summary={summaryProps}
          card={cartProps}
        />
      )) || (
        <>
          <CartHeader
            {...props}
            title={props.checkoutTitle}
            items={cart}
            showItemsCount={false}
            backTarget="cart"
          />
          <CartBody
            {...props}
            items={cart}
            pageType={PageType.CHECKOUT_PAGE}
          />
        </>
      )}
    </div>
  );
}
